// get Collateral Action
export const COLLATERAL_API_RESPONSE_SUCCESS = "COLLATERAL_API_RESPONSE_SUCCESS";
export const COLLATERAL_API_RESPONSE_ERROR = "COLLATERAL_API_RESPONSE_ERROR";
export const COLLATERAL_GET_AVAILABLE_MARGIN = "COLLATERAL_GET_AVAILABLE_MARGIN";
